import {
  BookOpenIcon,
  PrinterIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BookContext } from "../contexts/BookContext";

export const PrintCounterCard: FC = () => {
  const { t } = useTranslation();
  const { subscription } = useContext(BookContext);
  return (
    <div className="flex flex-col w-full p-4 sm:p-6 bg-white rounded-lg shadow-md">
      <p className="text-slate-700 text-xl sm:text-2xl font-bold">
        {t("dashboard.your_prints")}
      </p>
      <div className="w-full flex flex-col lg:flex-row justify-between space-y-4 lg:space-y-0 lg:space-x-6 items-start lg:items-center mt-4">
        <div className="flex flex-col sm:flex-row w-full lg:w-2/3 space-y-4 sm:space-y-0 sm:space-x-6">
          <div className="flex w-full sm:w-1/2 flex-row rounded-md bg-delicate-10 items-center px-2">
            <div className="bg-delicate-50 rounded-md m-2 p-1.5 sm:p-2">
              <BookOpenIcon className="w-5 h-5 sm:w-6 sm:h-6 text-delicate-800" />
            </div>
            <div className="pr-2">
              <p className="text-sm sm:text-base">
                {t("dashboard.bought_books")} : {subscription?.books_remaining}
              </p>
            </div>
          </div>
          <div className="flex w-full sm:w-1/2 flex-row rounded-md bg-delicate-10 items-center px-2">
            <div className="bg-delicate-50 rounded-md m-2 p-1.5 sm:p-2">
              <PrinterIcon className="w-5 h-5 sm:w-6 sm:h-6 text-delicate-800" />
            </div>
            <div className="pr-2">
              <p className="text-sm sm:text-base">
                {t("dashboard.printed_books")} : {subscription?.books_printed}
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-full lg:w-1/3 justify-start lg:justify-end">
          <a
            target="_blank"
            href={import.meta.env.VITE_MEMOIRS_UPSELL_PRINT_URL}
            className="flex w-full sm:w-80 items-center justify-center bg-rust-50 border border-rust-50 hover:bg-white text-white hover:text-rust-50 text-sm sm:text-lg rounded px-4 sm:px-6 py-2"
          >
            <ShoppingCartIcon className="h-5 w-5 sm:h-6 sm:w-6 mr-2" />
            {t("dashboard.buy_more")}
          </a>
        </div>
      </div>
    </div>
  );
};
